import { Injectable } from '@angular/core';
import { UsuarioAuth, UsuarioConectado } from '../../model/auth.model';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {

  public getStorage(): Storage {
    return sessionStorage.getItem('esLiferay') === 'true' ? sessionStorage : localStorage;
  }

  setAccessToken(token: string): void {
    this.getStorage().setItem('token', token);
  }

  getAccessToken(): string | null {
    return this.getStorage().getItem('token');
  }

  setRefreshToken(refreshToken: string): void {
    this.getStorage().setItem('refreshToken', refreshToken);
  }

  getRefreshToken(): string | null {
    return this.getStorage().getItem('refreshToken');
  }

  clearSession(): void {
    if (this.esEmbebido()){
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('username');
      sessionStorage.removeItem('usuarioConectado');
      sessionStorage.removeItem('usernameSuplantado');
      sessionStorage.removeItem('theme');
      sessionStorage.removeItem('embedded');
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('username');
      localStorage.removeItem('usuarioConectado');
      localStorage.removeItem('usernameSuplantado');
      localStorage.removeItem('theme');
    }
  }

  setUserInfo(usuario: UsuarioAuth): void {
    this.getStorage().setItem('username', usuario.username);
    if (usuario.tema && usuario.tema !== '') {
      this.setTema(usuario.tema);
    }
    if (usuario.embebido !== null) {
      this.getStorage().setItem('embedded', usuario.embebido ? 'true' : 'false');
    }
  }

  setUserSuplantadoInfo(usuario: UsuarioAuth): void {
    this.getStorage().setItem('usernameSuplantado', usuario.username);
  }

  getUserInfo(): UsuarioConectado {
    const storage = this.getStorage();
    const username = storage.getItem('username');
    const usernameSuplantado = storage.getItem('usernameSuplantado');
    const token = storage.getItem('token');
    const tema = storage.getItem('theme');
    const embebido = storage.getItem('embedded') === 'true';
    return { txtNombre: username, token: token, txtUsuarioSuplantado: usernameSuplantado, tema: tema, embebido: embebido };
  }

  esEmbebido(): boolean {
    return sessionStorage.getItem('embedded') === 'true';
  }

  setEmbebido(esLiferay: boolean){
    sessionStorage.setItem('embedded', String(esLiferay));
  }

  clearSuplantado(){
    this.getStorage().removeItem('usernameSuplantado');
  }

  getActiveUser(){
    const storage = this.getStorage();
    const username = storage.getItem('username');
    const usernameSuplantado = storage.getItem('usernameSuplantado');
    return usernameSuplantado || username;
  }

  getTema(){
    return this.getStorage().getItem('theme');
  }

  setTema(tema: string){
    this.getStorage().setItem('theme', tema);
  }
}


